// @flow
const configLocal = {
  name: "configLocal",
  baseName: "",
  oldDomainUrl: "https://zoom-ops-dev.stg.rivigo.com/#/",
  zoomApiUrl: "https://zoom-api-qa.stg.rivigo.com",
  ticketingApiUrl: "http://localhost:8090",
  loginUrl: "https://login.stg.rivigo.com/",
  logoutUrl: "https://login.stg.rivigo.com",
  primeOpcApiUrl: "https://opc-api.stg.rivigo.com"
};

export default configLocal;



// WEBPACK FOOTER //
// ./app/configs/configLocal.js